<!-- src/app/queries-list/queries-list.component.html -->
<div class="queries-container">
  <div class="queries-header">

    <!-- <div class="row">
      <div class="col-sm-12 compswitch">
        <div class="switch cswitch">
          <a href="javascript:void(0);" class="optionone compone" [ngClass]="{'active': selectedMatter === 'inquiry'}"(click)="onClick('inquiry')"> Inquiry </a>
        </div>
      </div>
    </div> -->

  </div>
  
  <div class="queries-content">
    <div class="list-header">
      <h5>List of Inquiries</h5>
      
      <div class="list-actions">
        <div class="search-box">
          <div class="input-group">
            <span class="input-group-text bg-transparent"><i class="bi bi-search"></i></span>
            <input 
              type="text" oninput="this.value = this.value.replace(/[^A-Za-z0-9 ]|^ /g,'')" 
              class="form-control" 
              placeholder="Search..." 
              [(ngModel)]="searchTerm"
              (ngModelChange)="onSearchChange()">
          </div>
        </div>
      </div>
    </div>
    
    <div class="queries-table" *ngIf="filteredQueries.length > 0">
      <table class="table">
        <thead>
          <tr>
            <th class="thdata" scope="col">Name<i class="bi bi-arrow-down-up biarr" (click)="sortQueries('name')"></i> </th>
            <th class="thdata" scope="col">Email<i class="bi bi-arrow-down-up biarr" (click)="sortQueries('email')"></i> </th>
            <th class="thdata" scope="col">Phone<i class="bi bi-arrow-down-up biarr" (click)="sortQueries('phone')"></i> </th>
            <th class="thdata" scope="col" style="width: 15%;">Created On<i class="bi bi-arrow-down-up biarr" (click)="sortQueries('created')"></i> </th>
            <th class="thdata" scope="col" style="width: 15%;">Departments<i class="bi bi-arrow-down-up biarr" (click)="sortQueries('department')"></i> </th>
            <th class="thdata" scope="col">Issues<i class="bi bi-arrow-down-up biarr" (click)="sortQueries('issue')"></i> </th>
            <th class="thdata" scope="col">Status<i class="bi bi-arrow-down-up biarr" (click)="sortQueries('status')"></i> </th>
            <th class="thdata" scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let query of getPaginatedqueries() | filter:searchTerm">
            <td>{{ query.name }}</td>
            <td>{{ query.email }}</td>
            <td>{{ query.phone }}</td>
            <td>{{ query.created }}</td>
            <td style="white-space: pre-line;">{{ query.department }}</td>
            <td>{{ query.issue }}</td>
            <!-- <td>{{ query.status }}</td> -->
             <td>{{ query.status === 'active' ? 'New' : query.status }}</td>
            <td>
              <div class="dropdown actions-dropdown">
                <button class="btn actions-menu" type="button" id="leadActions{{query.id}}" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="bi bi-three-dots-vertical"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end" [attr.aria-labelledby]="'leadActions' + query.id">
                  <li><a class="dropdown-item" href="javascript:void(0)" (click)="viewLeadDetails(query)">
                    <i class="bi bi-eye fontbi"></i> &nbsp; View Details
                  </a></li>
                  <li><a class="dropdown-item" href="javascript:void(0)" (click)="viewDownloadDetails(query)">
                    <i class="bi bi-download"></i> &nbsp; Download Details
                  </a></li>
                  <li><a class="dropdown-item" href="javascript:void(0)" (click)="openUpdateStatusModal(query)">
                    <i class="bi bi-pencil-square"></i> &nbsp; Update Status
                  </a></li>
                  <li><a class="dropdown-item" href="javascript:void(0)" (click)="addNotesModal(query)">
                    <i class="bi bi-plus-square"></i> &nbsp; Add Notes
                  </a></li>
                  <li><a class="dropdown-item" href="javascript:void(0)" (click)="generateLink(query)">
                    <i class="bi bi-link-45deg fontbigl"></i> &nbsp; Generate Link
                  </a></li>
                  <li><a class="dropdown-item" href="javascript:void(0)" (click)="viewDocuments(query)">
                    <i class="bi bi-file-earmark-text fontbi"></i> &nbsp; View Documents
                  </a></li>
                  <li><a class="dropdown-item" href="javascript:void(0)" (click)="confirmDelete(query.id)">
                    <i class="bi bi-trash fontbi"></i> &nbsp; Delete
                  </a></li>
                </ul>
              </div>
            </td>
          </tr>
          <!-- <tr *ngIf="filteredQueries.length === 0">
            <td colspan="8" class="text-center noleads">No queries found</td>
          </tr> -->
        </tbody>
      </table>
    </div>
    
    <div class="pagination-area" *ngIf="filteredQueries.length > 0">
      <div class="pagination-info">
        {{ getPaginationRange() }}
      </div>
      
      <nav aria-label="Leads pagination">
        <ul class="pagination mb-0">
          <li class="page-item" [ngClass]="{'disabled': currentPage === 1}">
            <a class="page-link" href="javascript:void(0)" (click)="changePage(currentPage - 1)">
              <i class="bi bi-chevron-left"></i> Previous
            </a>
          </li>
          
          <li *ngFor="let page of getPageNumbers()" class="page-item" [ngClass]="{'active': page === currentPage}">
            <a class="page-link" href="javascript:void(0)" (click)="changePage(page)">{{ page }}</a>
          </li>
          
          <li class="page-item" [ngClass]="{'disabled': currentPage === getTotalPages() || getTotalPages() === 0}">
            <a class="page-link" href="javascript:void(0)" (click)="changePage(currentPage + 1)">
              Next <i class="bi bi-chevron-right"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>

    <div *ngIf="filteredQueries.length === 0">
      <div colspan="6" class="text-center noleads">No Queries Found!!</div>
    </div>

  </div>
</div>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate"
  [fullScreen]="true">
</ngx-spinner>